import React, { useRef, useState, useEffect } from 'react';
import useCountUp from '../../hooks/useCountUp';

function CounterStat({ target, label }) {
  const ref = useRef(null);
  const [start, setStart] = useState(false);

  // 👇 só ativa quando aparecer na tela
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStart(true);
          observer.disconnect(); // roda só 1x
        }
      },
      { threshold: 0.5 } // 50% visível
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  // 👇 só roda o contador quando start = true
  const count = useCountUp(start ? target : 0, 5000);

  return (
    <div className="stat" ref={ref}>
      <span className="stat-num">{count}</span>
      <span className="stat-label">{label}</span>
    </div>
  );
}

export default CounterStat;